import AddDataSourceFilterRecordsByTypes from 'automation-ui-formula-editor/fetch-object-panel/constants/AddDataSourceFilterRecordsByTypes';
import { RecordFilterTypes } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
export function getFilterRecordsByType({
  recordFilterDefinition
}) {
  if (recordFilterDefinition.recordFilterType === RecordFilterTypes.MATCHING_PROPERTY) {
    var _recordFilterDefiniti;
    return ((_recordFilterDefiniti = recordFilterDefinition.matchingValue) === null || _recordFilterDefiniti === void 0 ? void 0 : _recordFilterDefiniti.type) === 'STATIC' ? AddDataSourceFilterRecordsByTypes.PROPERTY_VALUE : AddDataSourceFilterRecordsByTypes.MATCHING_PROPERTY;
  } else if (recordFilterDefinition.recordFilterType === RecordFilterTypes.ASSOCIATION_TIMESTAMP) {
    return AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL;
  } else {
    return recordFilterDefinition.recordFilterType;
  }
}